<template>
    <div class="color-container col-12 pb-3">
        <ValidationObserver ref="observer" novalidate>
            <div class="col-12 pb-0 mb-0">
                <div class="row pt-4 pb-2 pl-4 pr-4 reason-divider">
                    <span class="dot text-center pl-1">
                        <i class="fas fa-file-alt" />
                    </span>
                    <label for class="d-block bold text-left">
                        Razón de Rechazo
                    </label>
                </div>
                <div class="row m-0 p-4 main-content text-center">
                    <ValidationProvider
                        v-slot="{ errors }"
                        class="w-100 text-left"
                        name="tipyDropdown"
                        rules="required"
                    >
                        <label for class="d-block bold text-left">Tipo:</label>
                        <CustomDropDown
                            id="tipyDropdown"
                            v-model="selectedReason"
                            :error="errors[0]"
                            placeholder="Seleccione"
                            fieldkey="id"
                            fieldname="name"
                            :options="reasonOptions"
                            :clearable="false"
                            custom-error-msg="Favor seleccionar el tipo de razón."
                        />
                    </ValidationProvider>
                </div>
                <div class="row m-0 p-4 main-content text-center">
                    <div class="w-100">
                        <ValidationProvider
                            v-slot="{ errors }"
                            class="w-100 text-left info"
                            name="Comentario"
                            rules="required"
                        >
                            <CustomTextArea
                                :rows="3"
                                id="comment"
                                name="comment"
                                :maxlength="500"
                                :error="errors[0]"
                                label="Comentario:"
                                v-model="reasonComment"
                                :show-char-count="false"
                                placeholder="Ingrese comentario"
                                custom-error-msg="Campo Requerido."
                            />
                        </ValidationProvider>
                    </div>
                </div>
                <div class="w-100 my-2 pl-4">
                    <label for class="d-block bold text-left">Documento:</label>
                    <CustomFileInput
                        ref="fileUpload"
                        class="w-100 text-left info"
                        v-model="document"
                        display-style="normal"
                        :accept="'.pdf'"
                        :disabled="false"
                        :attachment-id="innerDocumentId"
                        :name="innerFileName"
                        @input="handleDocumentChange"
                    />
                </div>
                <div class="d-flex flex-row-reverse bd-highlight w-100 mb-2 actions">
                    <div class="mx-0 bd-highlight ml-2">
                        <ActionButton
                            variant="success"
                            i="fas fa-save"
                            @click="save"
                        >
                            Guardar
                        </ActionButton>
                    </div>
                    <div class="mx-0 bd-highlight ml-2">
                        <ActionButton
                            id="modal-btn-cancelar"
                            variant="outline-danger"
                            i="fas fa-times-circle"
                            @click="cancel"
                        >
                            Cancelar
                        </ActionButton>
                    </div>
                </div>
            </div>
        </ValidationObserver>
    </div>
</template>

<style scoped src="@/assets/css/component/panel-simple.css"></style>

<script>
import CustomFileInput from 'CustomFileInput';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomTextArea from '@/components/common/CustomTextArea';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import ActionButton from '@/components/common/ActionButton';
import referralStatus from "@/utils/constants/pei/referral/referralStatus";
import objectToFormData from "object-to-formdata";

export default {
  name: 'ReactivationForm',
  components: {
    CustomDropDown,
    CustomTextArea,
    CustomFileInput,
    ValidationObserver,
    ValidationProvider,
    ActionButton
  },
  props: {
    studentReferralId: {
      type: Number,
      default: 0
    },
    rejectOptionId: {
      type: Number,
      default: 0
    },
    rejectComment: {
      type: String,
      default: () => ""
    },
    rejectDocumentId: {
      type: String,
      default: () => ""
    },
    rejectDocumentName: {
      type: String,
      default: () => ""
    },
  },
  data() {
    return {
        selectedReason: null,
        reasonComment: this.rejectComment,
        document: null,
        reasonOptions: [],
        isFileChanged: false,
        innerFileName: this.rejectDocumentName,
        innerDocumentId: this.rejectDocumentId,
    };
  },
  methods: {
    async fetchRejectOptions() {
        const url = `api/studentevaluation/referralActionReasonsByStatusId?referralStatusId=${referralStatus.inactive}`;
        const { data } = await this.$ApiGet(url);
        this.reasonOptions = [...data];

        if (!!this.rejectOptionId) {
            this.selectedReason = this.reasonOptions.find(x => x.id == this.rejectOptionId);
        }
    },
    handleDocumentChange() {
        this.isFileChanged = true;
        this.innerFileName = null;
        this.innerDocumentId = null;
    },
    cancel() {
        this.$emit('cancel');
    },
    async save() {
        const isValid = await this.$refs.observer.validate();
        
        const hasNoChanges = this.reasonComment == this.rejectComment
            && this.selectedReason?.id == this.rejectOptionId
            && !this.isFileChanged;

        if (!isValid || hasNoChanges) return;        

        const payload = {
            StudentReferralId: this.studentReferralId,
            ReferralStatusId: referralStatus.inactive,
            Id: this.selectedReason?.id,
            Comment: this.reasonComment,
            Document: this.document,
            IsFileChanged: this.isFileChanged
        };
        const formData = objectToFormData(payload, { indices: true });
        formData.append(`document`, this.document);
        
        this.$emit('confirm', formData);
    },
  },
  async mounted() {
    await this.fetchRejectOptions();
  },
};
</script>

<style src="@/assets/css/component/badge.css"></style>
<style src="@/assets/css/component/textarea.css"></style>

<style scoped>
:root {
    --bg-eva-color: #f5eee9;
}
.color-container {
    background-color: #f5eee9;
    border-radius: 5px;
    opacity: 1;
}
#modal-btn-cancelar {
    background-color: var(--bg-eva-color);
}
#modal-btn-cancelar.outline-danger:hover {
    background-color: #c9545e;
    color: white;
}
.panel-row-without-selector {
    background: var(--bg-eva-color) !important;
}

.reason-divider {
    border-bottom: 1px solid white;
}
.dot {
    width: 24px;
    height: 24px;
    color: #ff7058;
    border-radius: 50%;
    display: inline-block;
    opacity: 1;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    padding-top: 1px;
    padding-right: 4px;
    margin-right: 5px;
}

.info >>> textarea {
    min-height: 38px;
}
</style>